import { IconMoon, IconSun } from "@tabler/icons-react";
import { useAtom } from "jotai";
import { appearanceAtom } from "@/stores/appearance-atom";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

export function ThemeSwitch() {
  const [appearance, setAppearance] = useAtom(appearanceAtom);

  function toggleTheme() {
    const newTheme = appearance.theme === "dark" ? "light" : "dark";
    setAppearance((prev) => ({ ...prev, theme: newTheme }));
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      className="focus-visible:ring-ring relative h-9 w-9 overflow-hidden rounded-full transition-colors hover:bg-transparent focus-visible:bg-transparent focus-visible:ring-1"
    >
      <div className="relative flex h-full w-full items-center justify-center">
        <span
          className={cn(
            "absolute inset-0 flex items-center justify-center transition-transform duration-500",
            appearance.theme === "dark" ? "translate-y-0" : "translate-y-10",
          )}
        >
          <IconMoon className="text-primary size-[1.2rem]" strokeWidth={2} />
        </span>
        <span
          className={cn(
            "absolute inset-0 flex items-center justify-center transition-transform duration-500",
            appearance.theme === "light" ? "translate-y-0" : "-translate-y-10",
          )}
        >
          <IconSun className="size-[1.2rem] text-amber-500" strokeWidth={2} />
        </span>
      </div>
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
}
